
/* injects from baggage-loader */

'use strict';

export default class CookiePolicyController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/legal/cookie-policy/cookie-policy.controller.js